import {CdMdsAnswerFactory} from './cd-mds-answer-factory';
import {CdMdsQuestion} from '../../../interfaces/care/cd-rai/cd-mds-question';
import {CdMdsAnswerOption} from '../../../interfaces/care/cd-rai/cd-mds-answer-option';
import {CdMdsAnswer} from '../../../interfaces/care/cd-rai/cd-mds-answer';
import {CdMdsAnswerOptionFactory} from './cd-mds-answer-option-factory';

export class CdMdsQuestionFactory {

  /**
   *
   * @param caMdsQuestion
   */
  public static fromObject(caMdsQuestion: any): CdMdsQuestion {
    return new class implements CdMdsQuestion {
      id: number = caMdsQuestion.id;
      cdMdsAreaId: number = caMdsQuestion.ca_mds_area_id;
      text: string = caMdsQuestion.text;
      info: string = caMdsQuestion.info;
      triggerCode: string = caMdsQuestion.trigger_code;
      triggerName: string = caMdsQuestion.trigger_name;
      questionGroup: number = caMdsQuestion.question_group;
      questionGroupName: string = caMdsQuestion.question_group_name;
      questionGroupParentId: number = caMdsQuestion.question_group_parent_id;
      questionGroupColor: string = caMdsQuestion.question_group_color;
      isNothingSelected: boolean = caMdsQuestion.is_nothing_selected;
      cdMdsAnswerOptions: CdMdsAnswerOption[] =
        caMdsQuestion.c_mds_answer_options ? CdMdsAnswerOptionFactory.fromArray(caMdsQuestion.c_mds_answer_options) : [];
      cdMdsAnswer: CdMdsAnswer = caMdsQuestion.c_mds_answer ? CdMdsAnswerFactory.fromObject(caMdsQuestion.c_mds_answer) : null;
      questionGroupSubtitle: string = caMdsQuestion.question_group_subtitle;
      questionGroupInfo: string = caMdsQuestion.question_group_info;
      title: string = caMdsQuestion.title;
      subtitle: string = caMdsQuestion.subtitle;
    };
  }

  /**
   *
   * @param caMdsQuestions
   */
  public static fromArray(caMdsQuestions: any[]): CdMdsQuestion[] {
    return caMdsQuestions.map(_caMdsQuestion => CdMdsQuestionFactory.fromObject(_caMdsQuestion));
  }

}
